import { extraProfileRoutes } from "./extra-profile-routes";

export default (router: any) => {
  extraProfileRoutes.forEach((route: any) => {
    router.addRoute(route);
  });
};
